import { Fragment, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import MixpanelActions from 'app/features/mixpanel/MixpanelActions';
import PageActions from 'app/store/page/page.actions';
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';
// Selectors
import { selectSelectedPageIds } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Messages
import { pageMessages } from 'app/store/page/page.messages';
// Mui
import { Tooltip } from '@mui/material';
// Components
import Icon from 'app/components/Icon';
import { IconButton } from 'app/components/Mui';
// Utils
import usePagesUtilities from '../utils/usePagesUtilities';

const WorkspaceToggleButtons = () => {
  const { pathname } = useLocation<{ pathname:string; }>();

  const isWorkspacePath = pathname.includes('/workspace');

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const selectedPageIds = useAppSelector(selectSelectedPageIds);

  const { getPagesByIds, updatePagesInWorkspace } = usePagesUtilities();

  const handleWorkspaceToggle = useCallback((inWorkspace:boolean = false) => () => {
    const pages = getPagesByIds(selectedPageIds);
    const updatedPages = updatePagesInWorkspace(pages, inWorkspace);
    if ( !updatedPages.length ) return;
    const message = inWorkspace
      ? updatedPages.length > 1 ? pageMessages.addPagesToWorkspace : pageMessages.addPageToWorkspace
      : updatedPages.length > 1 ? pageMessages.removePagesFromWorkspace : pageMessages.removePageFromWorkspace
    ;
    dispatch(PageActions.patchPages(updatedPages, message));
    // We will clear the selected pages when we are in the workspace path
    if ( isWorkspacePath ) dispatch(PagesToolbarActions.clearSelectedPages());

    dispatch(MixpanelActions.handleCasePagesBulkActionClick({ action: 'workspace', numberOfPages: updatedPages.length }));
  }, [dispatch, selectedPageIds, getPagesByIds, updatePagesInWorkspace, isWorkspacePath]);

  return (
    <Fragment>
      <Tooltip title="Add to workspace">
        <IconButton
          name="Add to workspace"
          onClick={handleWorkspaceToggle(true)}
        ><Icon icon="add_to_workspace" /></IconButton>
      </Tooltip>
      <Tooltip title="Remove from workspace">
        <IconButton
          name="Remove from workspace"
          onClick={handleWorkspaceToggle()}
        ><Icon icon="remove_from_workspace" /></IconButton>
      </Tooltip>
    </Fragment>
  )
}

export default WorkspaceToggleButtons;
